import React from 'react';

const CourseProgress = ({ availableCredits, totalCredits }) => {
    const totalcredits = totalCredits ?? 100;
    const userDetails = JSON.parse(localStorage.getItem('user'));
    const percentage = (availableCredits / totalcredits) * 100;
    return (

        <div className='flex md:w-[50%] lg:w-[50%] w-[80%] items-center'>

            {/* <p className='md:text-lg text-text_color3 font-bold text-left mx-2 '>Credit Points</p> */}

            <div class="md:h-[5vh] lg:h-[5vh] h-[2vh] relative  rounded-[10px] w-[100%] overflow-hidden border-2 bg-primary2 ">
                <div class=" bg-primary h-[6vh] rounded-l-[10px]  " style={{ width: `${percentage + '%'}` }}> </div>
                <p className='p-0 m-0 lg:mt-[4%] md:mt-[2%] absolute inset-0 lg:text-2xl text-xs md:text-lg font-bold text-center text-text_color3 '> {availableCredits}%
                    {/* / {totalcredits} */}
                </p>
            </div>
        </div>
    )

}

export default CourseProgress;